const DEFAULT_MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

/**
 * @param {string|undefined|null} period - Schools.period: empty/undefined and "monthly" → +1 month; else +4 (termly etc.)
 */
function isMonthlyBilling(period) {
  if (period === undefined || period === null) return true;
  const p = String(period).trim();
  if (p === "") return true;
  return p.toLowerCase() === "monthly";
}

/**
 * @param {string} dateYmd - Payment date YYYY-MM-DD
 * @param {string|undefined|null} period
 * @param {string[]} [monthsNames]
 * @returns {null|{ next: string, nextmonth: string, nextyear: number, nextday: string }}
 */
export function computeNextPaymentDue(dateYmd, period, monthsNames = DEFAULT_MONTHS) {
  const parts = String(dateYmd).trim().split("-");
  if (parts.length < 3) return null;
  const y = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  const d = parseInt(parts[2], 10);
  if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d) || m < 1 || m > 12 || d < 1 || d > 31) {
    return null;
  }

  const addMonths = isMonthlyBilling(period) ? 1 : 4;
  const next = new Date(y, m - 1, d);
  if (Number.isNaN(next.getTime())) return null;
  next.setMonth(next.getMonth() + addMonths);

  const pad2 = (n) => String(n).padStart(2, "0");
  const yN = next.getFullYear();
  const mN = next.getMonth() + 1;
  const dN = next.getDate();
  return {
    next: `${yN}-${pad2(mN)}-${pad2(dN)}`,
    nextmonth: monthsNames[mN - 1],
    nextyear: yN,
    nextday: String(dN)
  };
}
